document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'mb_recently_viewed';

  function readHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function record(handle) {
    if (!handle) return;
    try {
      var handles = readHandles().filter(function (h) { return h !== handle; });
      handles.unshift(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, 20)));
    } catch (e) {}
  }

  window.mbRecentlyViewed = { record: record, readHandles: readHandles };

  document.querySelectorAll('[data-mb-recently-viewed]').forEach(function (root) {
    var grid = root.querySelector('[data-mb-recently-viewed-grid]');
    if (!grid) return;

    var currentHandle = root.getAttribute('data-current-handle') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 5;
    var handles = readHandles().filter(function (h) { return h !== currentHandle; }).slice(0, limit);

    if (!handles.length) {
      root.remove();
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=mecca-wishlist-card-proxy')
          .then(function (res) { return res.ok ? res.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (htmlList) {
      var valid = htmlList.filter(function (html) { return html && html.trim().length; });
      if (!valid.length) {
        root.remove();
        return;
      }
      grid.innerHTML = valid.join('');
      root.hidden = false;

      if (window.mbWishlist) {
        grid.querySelectorAll('[data-mb-wish-toggle]').forEach(function (btn) {
          var h = btn.getAttribute('data-product-handle');
          var saved = window.mbWishlist.has(h);
          btn.classList.toggle('is-active', saved);
          btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        });
      }
    });
  });
});
